import React, { useState } from 'react';
import styles from './Header.module.css';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <header className={styles.header}>
      <div className={`${styles.container} ${styles.headerContent}`}>
        <a href="/" className={styles.logoLink}>
          <img src="/images/headerlogo.png" alt="Pizza Fresca Logo" className={styles.logo} />
        </a>

        {/* Mobile Menu Toggle */}
        <button className={styles.menuToggle} onClick={() => setIsNavOpen(!isNavOpen)} aria-label="Toggle navigation">
          <img src="/symbols/menu.png" alt="Menu" />
        </button>

        {/* Navigation Links */}
        <nav className={`${styles.nav} ${isNavOpen ? styles.navOpen : ''}`}>
          <ul className={`${styles.navLinks} ${isNavOpen ? styles.navActive : ''}`}>
            <li><a href="#about" onClick={() => setIsNavOpen(false)}>About</a></li>
            <li><a href="#services" onClick={() => setIsNavOpen(false)}>Services</a></li>
            <li><a href="#location-hours" onClick={() => setIsNavOpen(false)}>Visit Us</a></li>
            <li><a href="#contact" onClick={() => setIsNavOpen(false)}>Contact</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
